import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

import store from '../store'

const errorExceptions = [
  '/api/accountability_report'
]

const ApiService = {
  init () {
    Vue.use(VueAxios, axios)
    Vue.axios.defaults.baseURL = (process.env.NODE_ENV === 'production')
      ? process.env.VUE_APP_API_URL
      : process.env.VUE_APP_API_URL_DEV

    Vue.axios.interceptors.response.use(response => {
      return response
    }, (error) => {
      if (!errorExceptions.includes(error.response.config.url)) {
        const paramModal = {}

        paramModal.message = this.getMessage(error)
        paramModal.title = 'Ocorreu erro'
        paramModal.type = 'error'
        paramModal.callback = null
        paramModal.btConfirm = {
          name: 'Ok',
          show: true
        }
        paramModal.btCancel = {
          show: false
        }

        store.commit('confirmMessage/showConfirmMessage', paramModal)
      }

      store.commit('hideLoader')

      return error
    })
  },

  getMessage (error) {
    return error.response.data.errors ? Object.values(error.response.data.errors).join('<br>') : error.response.data.message
  },

  setHeader (token = '') {
    Vue.axios.defaults.headers.common['Authorization'] =
      token || this.getToken()
  },

  destroyToken () {
    localStorage.clear()
  },

  getToken () {
    const token = localStorage.getItem('token')

    if (token) return `Bearer ${localStorage.getItem('token')}`

    return ''
  },

  query (resource, params) {
    return Vue.axios.get(resource, params)
  },

  get (resource, slug = '') {
    return Vue.axios.get(slug ? `${resource}/${slug}` : `${resource}`)
  },

  post (resource, params) {
    return Vue.axios.post(`${resource}`, params)
  },

  update (resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params)
  },

  put (resource, params) {
    return Vue.axios.put(`${resource}`, params)
  },

  patch (resource, params) {
    return Vue.axios.patch(`${resource}`, params)
  },

  delete (resource) {
    return Vue.axios.delete(resource)
  }
}

export default ApiService
